import { TCAFirmBasicInformation } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export default function useCAFirmBasicInformation(caFirmId: string) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: TCAFirmBasicInformation;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    caFirmId ? `caFirm/${caFirmId}/basic-information` : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data: data?.caFirm,
    error,
    mutate,
  };
}
